import { useQuery } from "@tanstack/react-query";
import { getReportTopBrands } from "../../api/apiReports";

export const useGetReportTopBrands = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["report-top-brands", params],
        queryFn: () => getReportTopBrands(params),
        retry: false,
    });

    return {
        items: data?.data || [],
        isLoading,
        error,
        refetch,
    };
};
